export default function Hero() {
  return (
    <section className="relative bg-[#0B1120] pt-32 pb-20 overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: `radial-gradient(circle at 2px 2px, rgba(255,255,255,0.3) 1px, transparent 0)`,
          backgroundSize: '32px 32px'
        }}></div>
      </div>
      
      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#0B1120] via-[#0B1120]/95 to-[#1a2332]/80"></div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 text-center">
        {/* Animated Badge */}
        <div className="inline-flex items-center px-4 py-2 rounded-full bg-[#0066CC]/10 border border-[#0066CC]/20 mb-8 animate-pulse">
          <div className="w-2 h-2 bg-[#0066CC] rounded-full mr-3 animate-bounce"></div>
          <span className="text-[#0066CC] text-sm font-semibold whitespace-nowrap">
            Latest Insights & Intelligence
          </span>
        </div>
        
        {/* Main Heading */}
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
          Insights &{' '}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#0066CC] to-[#00a8ff]">
            Intelligence
          </span>
        </h1>
        
        {/* Subtitle */}
        <p className="text-xl text-gray-300 mb-12 max-w-3xl mx-auto leading-relaxed">
          Stay ahead of the curve with expert analysis on cybersecurity threats, cloud innovations, 
          AI advancements, and digital transformation strategies that shape the future of technology.
        </p>
        
        {/* Stats */}
        <div className="flex justify-center items-center space-x-8 text-gray-400">
          <div className="flex items-center space-x-2">
            <i className="ri-article-line text-[#0066CC]"></i>
            <span className="text-sm whitespace-nowrap">50+ Articles</span>
          </div>
          <div className="w-1 h-1 bg-gray-600 rounded-full"></div>
          <div className="flex items-center space-x-2">
            <i className="ri-team-line text-[#0066CC]"></i>
            <span className="text-sm whitespace-nowrap">Expert Authors</span>
          </div>
          <div className="w-1 h-1 bg-gray-600 rounded-full"></div>
          <div className="flex items-center space-x-2">
            <i className="ri-time-line text-[#0066CC]"></i>
            <span className="text-sm whitespace-nowrap">Weekly Updates</span>
          </div>
        </div>
      </div>
    </section>
  );
}